import SchoolLogo from "../assets/images/coewarri.png";
import AffiliateLogo from "../assets/images/IAUE.png";

export const InstitutionName = "College of Education, Warri (Postgraduate)";
export const AffiliateName =
  "Ignatius Ajuru University of Education, Port Harcourt";

export { SchoolLogo, AffiliateLogo };

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const paymentTypes = [
  {
    name: "School Fees",
    key: "schoolfees",
  },
  {
    name: "Certificate Fee",
    key: "certificate fee",
  },
  {
    name: "External Defense",
    key: "external defense",
  },
  {
    name: "Examination Fee",
    key: "exam fee",
  }
];

export const feesInstallment = [
  {
    name: "Full",
    key:"full"
  },
  {
    name: "First Installment",
    key:"first"
  },
  {
    name: "Second Installment",
    key:"second"
  }
]
